<template>
  <div ref="menstruation" class="menstruation-warp" v-show="show">
    <div class="symptom-list-wrapper">
      <div class="symptom-list">
        <div class="list-item">
          <div class="item-warp hover-c6e2ff" @click="addItem(item.label)" v-for="item in list1"
            :key="item.value">{{ item.label }}</div>
        </div>
      </div>
    </div>
    <div class="close-suggestions" @click="close">
      <i class="el-icon-circle-close mr8 size16"></i>
      关闭
    </div>
  </div>
</template>

<script>
import { isEmptyArray, isArray, isObject, isNull } from '@/utils/validateBase'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    assistantRemark: {
      type: String,
      default: ''
    },
  },
  watch: {
    assistantRemark: {
      handler(val) {
        this.assistantRemarkList = isNull(val) ? [] : val.split(',')
      },
      immediate: true
    }
  },
  data() {
    return {
      list1: [
        { value: '1', label: '推荐理疗' },
        { value: '2', label: '推荐产品' },
      ],
      assistantRemarkList:[]
    }
  },
  methods: {
    //添加每项内容
    addItem(item) {
      if (!this.assistantRemarkList.includes(item)) {
        this.assistantRemarkList.push(item);
        this.$emit('assistantRemarkChange', this.assistantRemarkList)
      }
    },
    close() {
      this.$emit('close')
    }

  }
}
</script>
<style lang="less">
.pregnancy-popover {
  min-width: 100px;
  padding: 6px;
  box-sizing: border-box;

  .el-popover__title {
    font-size: 12px;
    margin-bottom: 6px;
    text-align: center;
  }

  .pregnancy-num-warp {
    align-items: center;
    border-radius: 4px;
    color: #474747;
    cursor: pointer;
    display: inline-flex;
    font-size: 12px;
    height: 28px;
    justify-content: center;
    margin: 1px;
    width: 28px;
  }

  .hover-eff3f6 {
    &:hover {
      background-color: #eff3f6;
    }
  }
}
</style>
<style lang="less" scoped>
.hover-c6e2ff {
  &:hover {
    background-color: #c6e2ff;
    color: #0090ff
  }
}

.hover-eff3f6 {
  &:hover {
    background-color: #eff3f6;
  }
}

.menstruation-warp {
  background-color: #fff;
  border: 1px solid #b7b9c2;
  border-radius: 4px;
  font-size: 14px;
  left: 180px;
  min-width: 400px;
  position: absolute;
  width: 650px;
  z-index: 1009;
  bottom: -84px;

  .border-line {
    background-color: #dadbe0;
    font-size: 0;
    height: 1px;
    margin: 0 8px
  }

  .symptom-list-wrapper {
    padding: 0 7px;

    .symptom-list {
      display: flex;
      margin: 8px 0;
      padding: 0;

      .list-title {
        font-weight: 700;
        line-height: 1;
        margin: 0;
        min-width: 74px;
        padding: 5px 8px;
      }

      .list-item {
        display: flex;
        margin-bottom: 2px;
        align-items: center;
        flex-wrap: wrap;

        .item-warp {
          border-radius: 4px;
          color: #7a8794;
          cursor: pointer;
          display: inline-block;
          line-height: 1;
          padding: 5px 8px;
          user-select: none;
          white-space: nowrap;
        }

        .menstruation-info {
          display: inline-flex;
          flex-direction: column;
          width: 72px;

          .cut-line {
            border-bottom-color: #e0e2eb;
            height: 1px;
            width: 100%;
            background-color: #dadbe0;
            font-size: 0;
          }
        }

        .el-date-editor {
          width: 110px;
          cursor: pointer;

          /deep/.el-input__inner {
            font-size: 14px;
            border-radius: 4px;
            color: #7a8794;
            padding: 5px 8px;
            // padding-right: 0;
            border-color: transparent;

            &:hover {
              background-color: #eff3f6;
            }
          }
        }

        /deep/.el-input__prefix {
          display: none
        }


      }
    }

  }

  .close-suggestions {
    align-items: center;
    background: #f7f7f7;
    border-radius: 0 0 4px 4px;
    color: #005ed9;
    cursor: pointer;
    display: flex;
    font-weight: 500;
    height: 40px;
    justify-content: center;
    line-height: 40px;
    position: relative;
    width: 100%;
  }
}
</style>